/** Web-address fields: start with "https://" and add it when a typed address has no scheme. */
export const URL_PREFIX = 'https://';

/**
 * "example.com" -> "https://example.com". An address typed with its own scheme (http://...) is kept as typed; a
 * doubled prefix from pasting over the prefilled one ("https://https://x") is collapsed. Empty, or only the prefix,
 * is "" so optional fields stay unset.
 */
export function withHttps(raw: string): string {
  let v = raw.trim();
  while (/^https?:\/\/[a-z][a-z0-9+.-]*:\/\//i.test(v)) v = v.replace(/^https?:\/\//i, '');
  if (/^https?:\/\/$/i.test(v) || !v) return '';
  return /^[a-z][a-z0-9+.-]*:\/\//i.test(v) ? v : URL_PREFIX + v.replace(/^\/+/, '');
}

/** Props for an <input type="url">: prefill the prefix on focus, normalise on blur. */
export function urlFieldProps(value: string, set: (v: string) => void) {
  return {
    placeholder: `${URL_PREFIX}example.com`,
    onFocus: () => { if (!value) set(URL_PREFIX); },
    onBlur: () => set(withHttps(value)),
  };
}
